module.exports = __webpack_public_path__ + "img/product-icon_17.6e7683ef.png";